module.exports = __webpack_public_path__ + "img/542-42dfb3.png";